<template>
   <swiper
    :breakpoints="{
      0:   { slidesPerView: 1, spaceBetween: 12 },
      576: { slidesPerView: 1, spaceBetween: 16 },
      768: { slidesPerView: 2, spaceBetween: 24 },
      992: { slidesPerView: 2, spaceBetween: 30 },
    }"
    :pagination="{ clickable: true }"
    :navigation="true"
    :modules="modules"
    class="mySwiper"
    :autoplay="{ delay: 2500, disableOnInteraction: false }"
  >
    <swiper-slide>
      <img
        src="../assets/KarussellFeiern3-1.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/KarussellFeiern3-2.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/KarussellFeiern3-3.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
   
    <swiper-slide>
      <img
        src="../assets/KarussellFeiern3-5.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide><swiper-slide>
      <img
        src="../assets/KarussellFeiern3-6.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/KarussellFeiern3-7.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
   
  </swiper>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "../../assets/mySwiper.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { openModal } from "jenesius-vue-modal";
import ModalPic from "../components/Modals/ModalPic.vue";

export default {
  name: "karussellAktuelles1",
  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    async openPic(pic) {
      if (window.innerWidth >= 768) {
        const props = { adressePic: pic };
        const modal = await openModal(ModalPic, props);
        modal.onclose = () => {
          return true;
        };
      }
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
